import { render, staticRenderFns } from "./modalClosure.vue?vue&type=template&id=fefefb4c&scoped=true"
import script from "./modalClosure.vue?vue&type=script&lang=js"
export * from "./modalClosure.vue?vue&type=script&lang=js"
import style0 from "./modalClosure.vue?vue&type=style&index=0&id=fefefb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefefb4c",
  null
  
)

export default component.exports